import { API_KEY, APP_NAME, LOGGING_ENABLED } from '../config.js'
import { Tinode } from '../lib/tinode-sdk/tinode.js'

export function tnSetup(
  serverAddress,
  secureConnection,
  transport,
  locale,
  persistentCache,
  onSetupCompleted,
  platform = 'web',
  logging = true,
  globalConnection = true
) {
  const keyGlobal = typeof globalConnection == 'string' ? globalConnection : serverAddress
  if (
    globalConnection &&
    typeof window.globalConnectionsTinode != 'undefined' &&
    typeof window.globalConnectionsTinode[keyGlobal] != 'undefined'
  ) {
    setTimeout(() => {
      onSetupCompleted()
    }, 1)
    return window.globalConnectionsTinode[keyGlobal]
  }
  const params = {
    appName: APP_NAME,
    host: serverAddress,
    apiKey: API_KEY,
    transport: transport,
    secure: secureConnection,
    platform,
    persist: false // выключен кэш,
  }
  const tinode = new Tinode(params, onSetupCompleted)
  if (globalConnection) {
    if (typeof window.globalConnectionsTinode == 'undefined') {
      window.globalConnectionsTinode = {}
    }
    window.globalConnectionsTinode[keyGlobal] = tinode
  }
  tinode.setHumanLanguage(locale)
  tinode.enableLogging(logging)
  return tinode
}
